module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat1-7b21d139174ae2abe838631a03f1f15f.jpg";